export default {
      id: "drugs-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#drugs",
      toString: function () {
        return this.url;
      }
    }